/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Attribution for a loyalty account shared via family pool — identifies the pooled peer who owns the account.
 * @export
 * @interface SharedFromUser
 */
export interface SharedFromUser {
    /**
     * ID of the pooled peer who owns the loyalty account.
     * @type {string}
     * @memberof SharedFromUser
     */
    id: string;
    /**
     * Display name of the pooled peer.
     * @type {string}
     * @memberof SharedFromUser
     */
    name: string;
    /**
     * Email of the pooled peer.
     * @type {string}
     * @memberof SharedFromUser
     */
    email: string;
}

/**
 * Check if a given object implements the SharedFromUser interface.
 */
export function instanceOfSharedFromUser(value: object): value is SharedFromUser {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function SharedFromUserFromJSON(json: any): SharedFromUser {
    return SharedFromUserFromJSONTyped(json, false);
}

export function SharedFromUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedFromUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'email': json['email'],
    };
}

export function SharedFromUserToJSON(json: any): SharedFromUser {
    return SharedFromUserToJSONTyped(json, false);
}

export function SharedFromUserToJSONTyped(value?: SharedFromUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
    };
}

